const DEFAULT_LIST_FILTERS = {
  regions: [],
  units: [],
  departments: [],
  divisions: [],
  restaurants: [],
  positions: [],
  levels: [],
};

const DEFAULT_SELECTED_FILTERS = {
  regions: [],
  units: [],
  departments: [],
  divisions: [],
  restaurants: [],
  positions: [],
  levels: [],
};

const DEFAULT_MAX_LENGTH_FILTERS = {
  regions: 0,
  units: 0,
  departments: 0,
  divisions: 0,
  restaurants: 0,
  positions: 0,
  levels: 0,
};

const DEFAULT_OLD_SELECTED_FILTERS = {
  regions: {
    isSelctAll: false,
    regions: null,
  },
  units: {
    isSelctAll: false,
    units: null,
  },
  departments: {
    isSelctAll: false,
    departments: null,
  },
  divisions: {
    isSelctAll: false,
    divisions: null,
  },
  restaurants: {
    isSelctAll: false,
    restaurants: null,
  },
  positions: {
    isSelctAll: false,
    positions: null,
  },
  levels: {
    isSelctAll: false,
    levels: null,
  },
};
export const defaultState = {
  listFilters: DEFAULT_LIST_FILTERS,
  selectedFilters: DEFAULT_SELECTED_FILTERS,
  maxLengthFilters: DEFAULT_MAX_LENGTH_FILTERS,
  oldSelectedFilters: DEFAULT_OLD_SELECTED_FILTERS,
};
